import { BaseEvent, EnhancedEvent } from "../events/types";

type ComposeEnhancedEvent = (event: BaseEvent) => EnhancedEvent;

/**
 * Appends necessary properties to the event to be consumed by PostHog's capture method.
 *
 * @param event - Event
 * @returns Event with appended properties
 */
const composeEnhancedEvent: ComposeEnhancedEvent = (event) => {
  return {
    ...event,
    $ignore_sent_at: true,
  };
};

export { composeEnhancedEvent };
